import React from 'react';
import {TreeViewContext} from '../context';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {PopperProps} from '@mui/material';

/**
 * Check client/tree/DiplomatTreeMenu.java
 */
export const useBuildTreeContextMenu = () => {
   const [data, setData] = React.useState<INav>();
   const [anchorEl, setAnchorEl] = React.useState<PopperProps['anchorEl']>(null);

   const handleClick = React.useCallback(
      (data: INav) => (event: React.MouseEvent<HTMLElement>) => {
         // console.debug('handleClick context', event);

         event.preventDefault();
         event.stopPropagation();
         event.nativeEvent.stopImmediatePropagation();

         const rect = event.currentTarget.getBoundingClientRect();
         const newRect = {
            top: event.clientY,
            bottom: event.clientY,
            left: event.clientX,
            right: rect.right,
            y: event.clientY,
            x: event.clientX,
            height: rect.height,
            width: rect.width,
            toJSON: () => JSON.stringify(newRect),
         };

         // console.debug(rect, newRect);
         setAnchorEl({
            // clientHeight: rect.height,
            // clientWidth: rect.width,
            getBoundingClientRect: () => newRect,
         });
         setData(data);
         return false;
      },
      [setData, setAnchorEl]
   );

   const handleClose = React.useCallback(
      (ev?: React.MouseEvent<HTMLElement>) => {
         // console.debug('handleClose', ev);
         setAnchorEl(null);
      },
      [setAnchorEl]
   );

   const contextValue = React.useMemo(
      () =>
         ({
            data,
            anchorEl,
            handleClick,
            handleClose,
         } as TreeViewContext),
      [data, anchorEl, handleClose, handleClick]
   );

   return {
      contextValue,
   };
};
